import { useQuery } from "@tanstack/react-query";
import type { ControlcenterFetchInterface } from "@dealer-center/ddc-pages-controlcenter-interface";

const queryKeyBase = "ddc-pages-controlcenter";

export function useControlcenterAPIInterface({
  resource = "",
  asAccount = "",
  asUser = "",
  extraURLParams = ""
}: ControlcenterFetchInterface) {
  return useQuery({
    queryKey: [queryKeyBase, resource, extraURLParams],
    queryFn: async () => {
      const rstr = resource ? `/${resource}` : "";
      const res = await fetch(
        `/landing/nxlambda/controlcenter${rstr}?asAccount=${asAccount}&asUser=${asUser}${extraURLParams}`
      );
      if (res.ok) {
        return await res.json();
      } else {
        throw new Error(res.statusText);
      }
    },
    retry: 1,
    staleTime: 1000 * 60 * 5 // 5 minutes
  });
}
